import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioInicialConsultaConveniosInstrumentosCongeneres: ['exercicioInicial'],
    removeExercicioFinalConsultaConveniosInstrumentosCongeneres: ['exercicioFinal'],
    removeCodigoInicialConsultaConveniosInstrumentosCongeneres: ['codigoInicial'],
    removeCodigoFinalConsultaConveniosInstrumentosCongeneres: ['codigoFinal'],
    removeAssinaturaInicialConsultaConveniosInstrumentosCongeneres: ['assinaturaInicial'],
    removeAssinaturaFinalConsultaConveniosInstrumentosCongeneres: ['assinaturaFinal'],
    removeTipoConsultaConveniosInstrumentosCongeneres: ['tipo'],
    removeAdministracaoConsultaConveniosInstrumentosCongeneres: ['administracao'],
    removeUnidadeGestoraConsultaConveniosInstrumentosCongeneres: ['unidadeGestora'],
    removeConvenenteConsultaConveniosInstrumentosCongeneres: ['convenente'],
    removeConcedenteConsultaConveniosInstrumentosCongeneres: ['concedente'],
    removeIntervenienteConsultaConveniosInstrumentosCongeneres: ['interveniente'],
    removeObjetoConsultaConveniosInstrumentosCongeneres: ['objeto'],
    removeSituacaoConsultaConveniosInstrumentosCongeneres: ['situacao'],
    removeIdentificacaoExternaConsultaConveniosInstrumentosCongeneres: ['identificacaoExterna'],
    removeExercicioLicitacaoInicialConsultaConveniosInstrumentosCongeneres: ['exercicioLicitacaoInicial'],
    removeExercicioLicitacaoFinalConsultaConveniosInstrumentosCongeneres: ['exercicioLicitacaoFinal'],
    removeNumeroLicitacaoInicialConsultaConveniosInstrumentosCongeneres: ['numeroLicitacaoInicial'],
    removeNumeroLicitacaoFinalConsultaConveniosInstrumentosCongeneres: ['numeroLicitacaoFinal'],
    removeModalidadeLicitacaoConsultaConveniosInstrumentosCongeneres: ['modalidadeLicitacao'],
    setMostraAplicarFiltroConsultaConveniosInstrumentosCongeneres: [],
    limpaFiltroConsultaConveniosInstrumentosCongeneres: [],
    aplicarFiltroConsultaConveniosInstrumentosCongeneres: ['filtro'],
})

const INITIAL_STATE = {
    exercicioInicial: '',
    exercicioFinal: '',
    codigoInicial: '',
    codigoFinal: '',
    assinaturaInicial: '',
    assinaturaFinal: '',
    tipo: [],
    administracao: [],
    unidadeGestora: '',
    convenente: '',
    concedente: '',
    interveniente: '',
    objeto: '',
    situacao: [],
    exercicioLicitacaoInicial: '',
    exercicioLicitacaoFinal: '',
    numeroLicitacaoInicial: '',
    numeroLicitacaoFinal: '',
    modalidadeLicitacao: [],
    mostraAplicarFiltro: false,
}

const removeTipo = (state = INITIAL_STATE, action) => {
    state.tipo.splice(state.tipo.indexOf(action.tipo), 1)
    state.tipo = Array.from(state.tipo)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeModalidadeLicitacao = (state = INITIAL_STATE, action) => {
    state.modalidadeLicitacao.splice(state.modalidadeLicitacao.indexOf(action.modalidadeLicitacao), 1)
    state.modalidadeLicitacao = Array.from(state.modalidadeLicitacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: '', mostraAplicarFiltro: true }
}
const removeCodigoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, codigoInicial: '', mostraAplicarFiltro: true }
}
const removeCodigoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoFinal: '', mostraAplicarFiltro: true }
}
const removeAssinaturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaInicial: '', mostraAplicarFiltro: true }
}
const removeAssinaturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaFinal: '', mostraAplicarFiltro: true }
}
const removeUnidadeGestora = (state = INITIAL_STATE, action) => {
    return { ...state, unidadeGestora: '', mostraAplicarFiltro: true }
}
const removeConvenente = (state = INITIAL_STATE, action) => {
    return { ...state, convenente: '', mostraAplicarFiltro: true }
}
const removeConcedente = (state = INITIAL_STATE, action) => {
    return { ...state, concedente: '', mostraAplicarFiltro: true }
}
const removeInterveniente = (state = INITIAL_STATE, action) => {
    return { ...state, interveniente: '', mostraAplicarFiltro: true }
}
const removeObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: '', mostraAplicarFiltro: true }
}
const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}
const removeExercicioLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoInicial: '', mostraAplicarFiltro: true }
}
const removeExercicioLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoFinal: '', mostraAplicarFiltro: true }
}
const removeIdentificacaoExterna = (state = INITIAL_STATE, action) => {
    return { ...state, identificacaoExterna: '', mostraAplicarFiltro: true }
}
const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}
const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeExercicioInicial,
    [Types.REMOVE_EXERCICIO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeExercicioFinal,
    [Types.REMOVE_CODIGO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeCodigoInicial,
    [Types.REMOVE_CODIGO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeCodigoFinal,
    [Types.REMOVE_ASSINATURA_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeAssinaturaInicial,
    [Types.REMOVE_ASSINATURA_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeAssinaturaFinal,
    [Types.REMOVE_TIPO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeTipo,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeAdministracao,
    [Types.REMOVE_UNIDADE_GESTORA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeUnidadeGestora,
    [Types.REMOVE_IDENTIFICACAO_EXTERNA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeIdentificacaoExterna,
    [Types.REMOVE_CONVENENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeConvenente,
    [Types.REMOVE_CONCEDENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeConcedente,
    [Types.REMOVE_INTERVENIENTE_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeInterveniente,
    [Types.REMOVE_OBJETO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeObjeto,
    [Types.REMOVE_SITUACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeSituacao,
    [Types.REMOVE_EXERCICIO_LICITACAO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeExercicioLicitacaoInicial,
    [Types.REMOVE_EXERCICIO_LICITACAO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeExercicioLicitacaoFinal,
    [Types.REMOVE_NUMERO_LICITACAO_INICIAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeNumeroLicitacaoInicial,
    [Types.REMOVE_NUMERO_LICITACAO_FINAL_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeNumeroLicitacaoFinal,
    [Types.REMOVE_MODALIDADE_LICITACAO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: removeModalidadeLicitacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES]: aplicarFiltro,
})
